import { DataModel } from "common/models/utility-models/base-model"

export class RegisterStep4Model extends DataModel {
     
    instituteName:any=''
    instituteType:any=''
    instituteContact:any=''
    instituteAddress:any=''
    branchId:any=''
    firstYearFees:any=''
    collageStateId:any=''
    anyScholarship:any='false'
    anyScholarshipName:any=''
    offeringInstitute:any=''
    scholarshipAmount:any=''

}